import BaseFeature from '../../foundation/base/base';

class OnlineFundraising extends BaseFeature {
	constructor(element) {
		super(element);
		const e = document.getElementById('fund');
		if (e !== null) {
			const s = document.createElement('script');
			const x = document.getElementsByTagName('script')[0];
			s.type = 'text/javascript';
			s.async = !0;
			s.src = 'https://onlinefundraising.dk/js/3.8/iframe.js';
			x.parentNode.insertBefore(s, x);
		}
	}
}

export default OnlineFundraising;
